var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpDouble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8 8.707l3.646 3.647-.708.707L8 10.121l-2.938 2.94-.708-.707L8 8.707zm0-6.707L4.354 5.647l.708.707L8 2.121l2.938 2.94.708-.707L8 2zm0 4l3.646 3.647-.708.707L8 6.121l-2.938 2.94-.708-.707L8 6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpDouble);
export default __webpack_public_path__ + "static/media/ArrowUpDouble.19ec78e8a119385317ff1ee8b0c0ba5e.svg";
export { ForwardRef as ReactComponent };